/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-id-swiper/src/styles/css/swiper.css';
import Placeholder from '../../../../components/Placeholder';
import Image from '../../../../components/ContentfulImage';
import updateDiagnosisResult from '../../../../redux/actions/diagnosisResult';

import {
  SubTitle,
  Container,
  Contents,
  HowToTab,
  HowToTabItem,
  PowerContainerWrap,
  PowerProgram,
  PowerTitle,
  PowerValueContainer,
  RadioItem,
  HAIR_CARE,
  SCALP_CARE,
  FregranceChoice,
  FregranceChoiceTitle,
  FregranceChoiceContent,
  FregranceChoiceItem,
  ItemChoice,
  ItemChoiceTitle,
  ItemChoiceContent,
  ItemChoiceItem,
  Navi,
  AttentionText,
  AttentionIcon,
} from '../Common/Common.style';
import CareMenuImage from '../CareMenuImage/CareMenuImage';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE } from '../CareMenuImage/CareMenuImageConst';
import {
  Wrapper,
  Layout,
  LayoutLeft,
  LayoutRight,
  Title,
  PowerContainer,
  ImageContainer,
  Icon,
} from './HairAndScalpCarePage.style';
import DiagnosisResultListCard from '../DiagnosisResultListCard/DiagnosisResultListCard';
import DiagnosisResultStepCard from '../DiagnosisResultStepCard/DiagnosisResultStepCard';
import DiagnosisResultItemListCard from '../DiagnosisResultItemListCard/DiagnosisResultItemListCard';

class HairAndScalpCarePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCardHair: {
        isOpen: false,
      },
      listCardScalp: {
        isOpen: false,
      },
      stepCardHair: {
        isOpen: false,
      },
      stepCardScalp: {
        isOpen: false,
      },
      inFillListCard: {
        isOpen: false,
      },
      maskListCard: {
        isOpen: false,
      },
      preCleanseShampooListCard: {
        isOpen: false,
      },
    };
  }

  handleSelectCare = (category, index) => {
    if (category === CATEGORY_HAIRCARE) {
      this.props.updateDiagnosisResult({
        selectedHairCare: this.props.hairCareItemsInfo[index],
        selectedHairCareIndex: index,
      });
    } else if (category === CATEGORY_SCALPCARE) {
      this.props.updateDiagnosisResult({
        selectedScalpCare: this.props.scalpCareItemsInfo[index],
        selectedScalpCareIndex: index,
      });
    }
  };

  handleSelectInFillItem = index => {
    this.props.updateDiagnosisResult({
      selectedInFillItem: this.props.inFillItemsInfo[index] || null,
      selectedInFillItemIndex: index,
    });
  };

  handleSelectMaskItem = index => {
    this.props.updateDiagnosisResult({
      selectedMaskItem: this.props.maskItemsInfo[index] || null,
      selectedMaskItemIndex: index,
    });
    this.props.handleChangeHomeCareHairItems(this.props.maskItemsInfo[index] || null);
  };

  handleSelectPreCleanseShampooItem = index => {
    this.props.updateDiagnosisResult({
      selectedPreCleanseShampooItem: this.props.preCleanseShampooItemsInfo[index] || null,
      selectedPreCleanseShampooItemIndex: index,
    });
    this.props.handleChangeHomeCareScalpItems(this.props.preCleanseShampooItemsInfo[index] || null);
  };

  handleSelectAromaItem = (item, index) => {
    this.props.updateDiagnosisResult({
      selectedAromaItem: this.props.aromaItemsInfo[index] || null,
      selectedAromaItemIndex: index,
    });
  };

  handleSelectAdenovitalItem = (item, index) => {
    this.props.updateDiagnosisResult({
      selectedAdenovitalItem: this.props.adenovitalItemsInfo[index] || null,
      selectedAdenovitalItemIndex: index,
    });
  };

  handleOpenListCard = category => {
    if (category === CATEGORY_HAIRCARE) {
      this.setState({
        listCardHair: { isOpen: true },
      });
      this.props.handleOpenModal();
    } else if (category === CATEGORY_SCALPCARE) {
      this.setState({
        listCardScalp: { isOpen: true },
      });
      this.props.handleOpenModal();
    }
  };

  handleCloseListCard = category => {
    if (category === CATEGORY_HAIRCARE) {
      this.setState({
        listCardHair: { isOpen: false },
      });
      this.props.handleCloseModal();
    } else if (category === CATEGORY_SCALPCARE) {
      this.setState({
        listCardScalp: { isOpen: false },
      });
      this.props.handleCloseModal();
    }
  };

  handleOpenStepCard = category => {
    if (category === CATEGORY_HAIRCARE) {
      this.setState({
        stepCardHair: { isOpen: true },
      });
      this.props.handleOpenModal();
    } else if (category === CATEGORY_SCALPCARE) {
      this.setState({
        stepCardScalp: { isOpen: true },
      });
      this.props.handleOpenModal();
    }
  };

  handleCloseStepCard = category => {
    if (category === CATEGORY_HAIRCARE) {
      this.setState({
        stepCardHair: { isOpen: false },
      });
      this.props.handleCloseModal();
    } else if (category === CATEGORY_SCALPCARE) {
      this.setState({
        stepCardScalp: { isOpen: false },
      });
      this.props.handleCloseModal();
    }
  };

  handleOpenInFillListCard = () => {
    this.setState({
      inFillListCard: { isOpen: true },
    });
    this.props.handleOpenModal();
  };

  handleCloseInFillListCard = () => {
    this.setState({
      inFillListCard: { isOpen: false },
    });
    this.props.handleCloseModal();
  };

  handleOpenMaskListCard = () => {
    this.setState({
      maskListCard: { isOpen: true },
    });
    this.props.handleOpenModal();
  };

  handleCloseMaskListCard = () => {
    this.setState({
      maskListCard: { isOpen: false },
    });
    this.props.handleCloseModal();
  };

  handleOpenPreCleanseShampooListCard = () => {
    this.setState({
      preCleanseShampooListCard: { isOpen: true },
    });
    this.props.handleOpenModal();
  };

  handleClosePreCleanseShampooListCard = () => {
    this.setState({
      preCleanseShampooListCard: { isOpen: false },
    });
    this.props.handleCloseModal();
  };

  renderPower = power => {
    const indents = [];
    for (let i = 0; i < 4; i += 1) {
      if (i < power) {
        indents.push(<li key={i} className="active" />);
      } else {
        indents.push(<li key={i} />);
      }
    }
    return indents;
  };

  renderTitle = title => {
    const tits = title.split('、');
    return tits.map((e, i) => (i === tits.length - 1 ? <div key={i}>{e}</div> : <div key={i}>{`${e}、`}</div>));
  };

  renderPrice = (price, authSalonSettingData, locale) => {
    if (
      price &&
      authSalonSettingData &&
      authSalonSettingData.basicSettings &&
      authSalonSettingData.basicSettings.currencyCode
    ) {
      const localeName = locale.split('_')[0];
      const currencyName = authSalonSettingData.basicSettings.currencyCode;
      return new Intl.NumberFormat(localeName, { style: 'currency', currency: currencyName }).format(price);
    }
    return null;
  };

  renderRednessText = stylistDiagnosisResults => {
    const { copy } = this.props;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      const scalpmenudamageText =
        sublimicDiagnosisResultsCopy &&
        sublimicDiagnosisResultsCopy.salonCare &&
        sublimicDiagnosisResultsCopy.salonCare.scalpmenudamage;
      if (scalpmenudamageText) {
        for (let i = 0; i < Questions.length; i += 1) {
          if (Questions[i].slug === 'fq-redness') {
            if (Questions[i].answers[0] === 'ans-red') {
              return (
                <AttentionText>
                  <div className="attention-text__text" style={{ marginTop: 40, marginBottom: 0 }}>
                    {scalpmenudamageText}
                  </div>
                </AttentionText>
              );
            }
            return null;
          }
        }
      }
      return null;
    }
    return null;
  };

  // renderRednessIcon = stylistDiagnosisResults => {
  //   if (
  //     stylistDiagnosisResults &&
  //     stylistDiagnosisResults.result &&
  //     stylistDiagnosisResults.result.scalpDiagnosis &&
  //     stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
  //     stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
  //   ) {
  //     const Questions =
  //       stylistDiagnosisResults &&
  //       stylistDiagnosisResults.result &&
  //       stylistDiagnosisResults.result.scalpDiagnosis &&
  //       stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
  //       stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
  //     for (let i = 0; i < Questions.length; i += 1) {
  //       if (Questions[i].slug === 'fq-redness') {
  //         if (Questions[i].answers[0] === 'ans-red') {
  //           return <AttentionIcon>!</AttentionIcon>;
  //         }
  //         return null;
  //       }
  //     }
  //   }
  //   return null;
  // };

  renderRecommend = (stylistDiagnosisResults, index, sublimicDiagnosisResultsCopy) => {
    //
    const { authSalonSettingData } = this.props;
    const slugs = [];
    authSalonSettingData.salonMenus.spas.map(spa => {
      slugs.push(spa.slug);
    });
    if (slugs.indexOf('SS-S-Gray') === -1 && slugs.indexOf('SS-S-Growth') === -1) {
      return null;
    } else if (
      slugs.indexOf('SS-S-Complete') === -1 &&
      slugs.indexOf('SS-S-Lifting') === -1 &&
      slugs.indexOf('SS-S-SolvingProblem') === -1
    ) {
      return null;
    }
    //
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-redness') {
          if (Questions[i].answers[0] === 'ans-red') {
            return null;
          }
        }
      }
    }
    if (
      index === 0 &&
      sublimicDiagnosisResultsCopy &&
      sublimicDiagnosisResultsCopy.salonCare &&
      sublimicDiagnosisResultsCopy.salonCare.recommend
    ) {
      return <span className="recommend">{sublimicDiagnosisResultsCopy.salonCare.recommend}</span>;
    }
  };

  renderHairCare = () => {
    const {
      copy,
      locale,
      authSalonSettingData,
      hairCareItemsInfo,
      inFillItemsInfo,
      maskItemsInfo,
      diagnosisResult,
    } = this.props;
    const {
      selectedHairCare,
      selectedHairCareIndex,
      selectedInFillItem,
      selectedInFillItemIndex,
      selectedMaskItem,
      selectedMaskItemIndex,
    } = diagnosisResult;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    return (
      <React.Fragment>
        <Wrapper>
          {hairCareItemsInfo &&
            hairCareItemsInfo.map((item, index) => {
              if (selectedHairCareIndex === index) {
                return (
                  <div key={index}>
                    <Layout>
                      <LayoutLeft>
                        <Title>
                          {(item.title && this.renderTitle(item.title)) || <Placeholder w="300px" h="45px" />}
                        </Title>
                        <PowerContainerWrap>
                          {item.features &&
                            item.features.map((feature, index) => (
                              <PowerContainer key={index}>
                                {feature.name && <PowerTitle>{feature.name}</PowerTitle>}
                                {feature.value && (
                                  <PowerValueContainer>
                                    <ul className="powerbar">{this.renderPower(feature.value)}</ul>
                                  </PowerValueContainer>
                                )}
                              </PowerContainer>
                            ))}
                          <PowerProgram>
                            <div className="title">
                              {(item.salonSetting && `${item.salonSetting.displayName} : `) || (
                                <Placeholder w="143px" h="19px" />
                              )}
                            </div>
                            <div className="caption">
                              {item.salonSetting &&
                                item.salonSetting.operationTime &&
                                `${item.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
                              {item.salonSetting &&
                                item.salonSetting.price && (
                                  <React.Fragment>
                                    {this.renderPrice(item.salonSetting.price, authSalonSettingData, locale)}
                                  </React.Fragment>
                                )}
                            </div>
                          </PowerProgram>
                        </PowerContainerWrap>
                      </LayoutLeft>
                      <LayoutRight>
                        <ImageContainer>
                          {index === 0 &&
                            sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.salonCare &&
                            sublimicDiagnosisResultsCopy.salonCare.recommend && (
                              <span className="recommend">{sublimicDiagnosisResultsCopy.salonCare.recommend}</span>
                            )}
                          <CareMenuImage category={CATEGORY_HAIRCARE} />
                        </ImageContainer>
                      </LayoutRight>
                    </Layout>
                  </div>
                );
              }
              return null;
            })}
          <HowToTab>
            <HowToTabItem
              className="active"
              onClick={() => {
                this.handleOpenListCard(CATEGORY_HAIRCARE);
              }}
            >
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.salonCare &&
                sublimicDiagnosisResultsCopy.salonCare.menuCompareCtaLabel) || <Placeholder w="130px" h="50px" />}
            </HowToTabItem>
            <HowToTabItem
              onClick={() => {
                this.handleOpenStepCard(CATEGORY_HAIRCARE);
              }}
            >
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.salonCare &&
                sublimicDiagnosisResultsCopy.salonCare.stepCtaLabel) || <Placeholder w="130px" h="50px" />}
            </HowToTabItem>
          </HowToTab>
          <ItemChoice>
            <ItemChoiceTitle>
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.salonCare &&
                sublimicDiagnosisResultsCopy.salonCare.useItemLabel) || <Placeholder w="200px" h="16px" />}
            </ItemChoiceTitle>
            <ItemChoiceContent>
              {selectedInFillItem && (
                <ItemChoiceItem onClick={this.handleOpenInFillListCard}>
                  <div className="image">
                    {selectedInFillItem.itemIcon ? (
                      <Image src={selectedInFillItem.itemIcon} options={{ w: '50px', h: '50px' }} />
                    ) : (
                      <Placeholder w="50px" h="50px" />
                    )}
                  </div>
                  <div className="text">
                    {(selectedInFillItem.product && selectedInFillItem.product.name) || (
                      <Placeholder w="100%" h="16px" />
                    )}
                  </div>
                </ItemChoiceItem>
              )}
              {selectedMaskItem && (
                <ItemChoiceItem onClick={this.handleOpenMaskListCard}>
                  <div className="image">
                    {selectedMaskItem.itemIcon ? (
                      <Image src={selectedMaskItem.itemIcon} options={{ w: '50px', h: '50px' }} />
                    ) : (
                      <Placeholder w="50px" h="50px" />
                    )}
                  </div>
                  <div className="text">
                    {(selectedMaskItem.product && selectedMaskItem.product.name) || <Placeholder w="100%" h="16px" />}
                  </div>
                </ItemChoiceItem>
              )}
            </ItemChoiceContent>
          </ItemChoice>
        </Wrapper>
        <DiagnosisResultListCard
          diagnosisResultType={HAIR_CARE}
          isOpen={this.state.listCardHair.isOpen}
          handleCloseCard={() => {
            this.handleCloseListCard(CATEGORY_HAIRCARE);
          }}
          handleSelectCare={index => {
            this.handleSelectCare(CATEGORY_HAIRCARE, index);
          }}
          selectedIndex={selectedHairCareIndex}
          careData={hairCareItemsInfo}
        />
        <DiagnosisResultStepCard
          diagnosisResultType={HAIR_CARE}
          careItem={selectedHairCare}
          isOpen={this.state.stepCardHair.isOpen}
          handleCloseCard={() => {
            this.handleCloseStepCard(CATEGORY_HAIRCARE);
          }}
        />
        <DiagnosisResultItemListCard
          isOpen={this.state.inFillListCard.isOpen}
          handleSelectItem={this.handleSelectInFillItem}
          handleCloseCard={this.handleCloseInFillListCard}
          selectedIndex={selectedInFillItemIndex}
          itemsInfo={inFillItemsInfo}
        />
        <DiagnosisResultItemListCard
          isOpen={this.state.maskListCard.isOpen}
          handleSelectItem={this.handleSelectMaskItem}
          handleCloseCard={this.handleCloseMaskListCard}
          selectedIndex={selectedMaskItemIndex}
          itemsInfo={maskItemsInfo}
        />
      </React.Fragment>
    );
  };

  renderScalpCare = () => {
    const {
      copy,
      locale,
      authSalonSettingData,
      scalpCareItemsInfo,
      adenovitalItemsInfo,
      aromaItemsInfo,
      preCleanseShampooItemsInfo,
      diagnosisResult,
      stylistDiagnosisResults,
    } = this.props;
    const {
      selectedScalpCare,
      selectedScalpCareIndex,
      selectedAdenovitalItemIndex,
      selectedAromaItemIndex,
      selectedPreCleanseShampooItem,
      selectedPreCleanseShampooItemIndex,
    } = diagnosisResult;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    return (
      <React.Fragment>
        <Wrapper>
          {scalpCareItemsInfo &&
            scalpCareItemsInfo.map((item, index) => {
              if (selectedScalpCareIndex === index) {
                return (
                  <div key={index}>
                    {this.renderRednessText(stylistDiagnosisResults)}
                    {/* {this.renderRednessIcon(stylistDiagnosisResults)} */}
                    <Layout>
                      <LayoutLeft>
                        <Title>
                          {(item.title && this.renderTitle(item.title)) || <Placeholder w="300px" h="45px" />}
                        </Title>
                        <PowerContainerWrap>
                          {item.features &&
                            item.features.map((feature, index) => (
                              <PowerContainer key={index}>
                                {feature.name && <PowerTitle>{feature.name}</PowerTitle>}
                                {feature.value && (
                                  <PowerValueContainer theme={SCALP_CARE}>
                                    <ul className="powerbar">{this.renderPower(feature.value)}</ul>
                                  </PowerValueContainer>
                                )}
                              </PowerContainer>
                            ))}
                          <PowerProgram>
                            <div className="title">
                              {(item.salonSetting && `${item.salonSetting.displayName} : `) || (
                                <Placeholder w="143px" h="19px" />
                              )}
                            </div>
                            <div className="caption">
                              {item.salonSetting &&
                                item.salonSetting.operationTime &&
                                `${item.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
                              {item.salonSetting &&
                                item.salonSetting.price && (
                                  <React.Fragment>
                                    {this.renderPrice(item.salonSetting.price, authSalonSettingData, locale)}
                                  </React.Fragment>
                                )}
                            </div>
                          </PowerProgram>
                        </PowerContainerWrap>
                      </LayoutLeft>
                      <LayoutRight>
                        <ImageContainer>
                          {this.renderRecommend(stylistDiagnosisResults, index, sublimicDiagnosisResultsCopy)}
                          {/* {index === 0 &&
                            sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.salonCare &&
                            sublimicDiagnosisResultsCopy.salonCare.recommend && (
                              <span className="recommend">{sublimicDiagnosisResultsCopy.salonCare.recommend}</span>
                            )} */}
                          <CareMenuImage category={CATEGORY_SCALPCARE} />
                        </ImageContainer>
                      </LayoutRight>
                    </Layout>
                  </div>
                );
              }
              return null;
            })}
          <HowToTab>
            <HowToTabItem
              className="active"
              onClick={() => {
                this.handleOpenListCard(CATEGORY_SCALPCARE);
              }}
            >
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.salonCare &&
                sublimicDiagnosisResultsCopy.salonCare.menuCompareCtaLabel) || <Placeholder w="130px" h="50px" />}
            </HowToTabItem>
            <HowToTabItem
              onClick={() => {
                this.handleOpenStepCard(CATEGORY_SCALPCARE);
              }}
            >
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.salonCare &&
                sublimicDiagnosisResultsCopy.salonCare.stepCtaLabel) || <Placeholder w="130px" h="50px" />}
            </HowToTabItem>
          </HowToTab>
          {selectedPreCleanseShampooItem && (
            <ItemChoice>
              <ItemChoiceTitle>
                {(sublimicDiagnosisResultsCopy &&
                  sublimicDiagnosisResultsCopy.salonCare &&
                  sublimicDiagnosisResultsCopy.salonCare.useItemLabel) || <Placeholder w="200px" h="16px" />}
              </ItemChoiceTitle>
              <ItemChoiceContent>
                <ItemChoiceItem onClick={this.handleOpenPreCleanseShampooListCard}>
                  <div className="image">
                    {selectedPreCleanseShampooItem.itemIcon ? (
                      <Image src={selectedPreCleanseShampooItem.itemIcon} options={{ w: '50px', h: '50px' }} />
                    ) : (
                      <Placeholder w="50px" h="50px" />
                    )}
                  </div>
                  <div className="text">
                    {(selectedPreCleanseShampooItem.product &&
                      selectedPreCleanseShampooItem.concern.appealShortText) || <Placeholder w="100%" h="16px" />}
                  </div>
                </ItemChoiceItem>
              </ItemChoiceContent>
            </ItemChoice>
          )}
          {aromaItemsInfo && (
            <FregranceChoice>
              <FregranceChoiceTitle>
                {(sublimicDiagnosisResultsCopy &&
                  sublimicDiagnosisResultsCopy.salonCare &&
                  sublimicDiagnosisResultsCopy.salonCare.selectFragrance) || <Placeholder w="200px" h="16px" />}
              </FregranceChoiceTitle>
              <FregranceChoiceContent>
                {aromaItemsInfo.map((item, index) => (
                  <FregranceChoiceItem key={index}>
                    <RadioItem>
                      <input
                        type="radio"
                        name="name"
                        id={item.slug}
                        onChange={() => this.handleSelectAromaItem(item, index)}
                        checked={selectedAromaItemIndex === index}
                      />
                      <label htmlFor={item.slug}>
                        <div className="image">
                          <Image src={item.itemIcon} />
                        </div>
                        <div className="info">
                          {index === 0 &&
                            sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.salonCare &&
                            sublimicDiagnosisResultsCopy.salonCare.Refresh && (
                              <div className="title">{sublimicDiagnosisResultsCopy.salonCare.Refresh}</div>
                            )}
                          {index === 1 &&
                            sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.salonCare &&
                            sublimicDiagnosisResultsCopy.salonCare.Relax && (
                              <div className="title">{sublimicDiagnosisResultsCopy.salonCare.Relax}</div>
                            )}
                          <div className="description">{item.ingredients ? item.ingredients.join('、') : ''}</div>
                        </div>
                      </label>
                    </RadioItem>
                  </FregranceChoiceItem>
                ))}
              </FregranceChoiceContent>
            </FregranceChoice>
          )}
          {adenovitalItemsInfo && (
            <FregranceChoice>
              <FregranceChoiceTitle>
                {(sublimicDiagnosisResultsCopy &&
                  sublimicDiagnosisResultsCopy.salonCare &&
                  sublimicDiagnosisResultsCopy.salonCare.useItemLabel) || <Placeholder w="200px" h="16px" />}
              </FregranceChoiceTitle>
              <FregranceChoiceContent>
                {adenovitalItemsInfo.map((item, index) => (
                  <FregranceChoiceItem key={index}>
                    <RadioItem>
                      <input
                        type="radio"
                        name="name"
                        id={item.slug}
                        onChange={() => this.handleSelectAdenovitalItem(item, index)}
                        checked={selectedAdenovitalItemIndex === index}
                      />
                      <label htmlFor={item.slug}>
                        <div className="image">
                          <Image src={item.itemIcon} />
                        </div>
                        <div className="info">
                          <div className="title">{item.product.name}</div>
                        </div>
                      </label>
                    </RadioItem>
                  </FregranceChoiceItem>
                ))}
              </FregranceChoiceContent>
            </FregranceChoice>
          )}
        </Wrapper>
        <DiagnosisResultListCard
          diagnosisResultType={SCALP_CARE}
          isOpen={this.state.listCardScalp.isOpen}
          handleCloseCard={() => {
            this.handleCloseListCard(CATEGORY_SCALPCARE);
          }}
          handleSelectCare={index => {
            this.handleSelectCare(CATEGORY_SCALPCARE, index);
          }}
          selectedIndex={selectedScalpCareIndex}
          careData={scalpCareItemsInfo}
        />
        <DiagnosisResultStepCard
          diagnosisResultType={SCALP_CARE}
          careItem={selectedScalpCare}
          isOpen={this.state.stepCardScalp.isOpen}
          handleCloseCard={() => {
            this.handleCloseStepCard(CATEGORY_SCALPCARE);
          }}
        />
        <DiagnosisResultItemListCard
          isOpen={this.state.preCleanseShampooListCard.isOpen}
          handleSelectItem={this.handleSelectPreCleanseShampooItem}
          handleCloseCard={this.handleClosePreCleanseShampooListCard}
          selectedIndex={selectedPreCleanseShampooItemIndex}
          itemsInfo={preCleanseShampooItemsInfo}
        />
      </React.Fragment>
    );
  };

  render() {
    const { copy, changeCurrentScene } = this.props;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    // console.log('@ HairAndScalpCarePage', this.props);
    return (
      <Container>
        <Contents>
          <SubTitle>
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.salonCare &&
              sublimicDiagnosisResultsCopy.salonCare.hairScalpTitle) || <Placeholder w="200px" h="24px" />}
          </SubTitle>
          {this.renderHairCare()}
          <Icon>+</Icon>
          {this.renderScalpCare()}
        </Contents>
        <Navi>
          <button
            className="navi__button"
            type="button"
            onClick={e => {
              e.preventDefault();
              if (changeCurrentScene) changeCurrentScene('home-care');
            }}
          >
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.HomeCare &&
              sublimicDiagnosisResultsCopy.HomeCare.nextCtaLabel) || <Placeholder w="100px" h="16px" />}
          </button>
        </Navi>
      </Container>
    );
  }
}

HairAndScalpCarePage.defaultProps = {
  copy: {},
  salonSolutionData: {},
  authSalonSettingData: {},
  diagnosisResult: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  sublimicDiagnosisLogics: {},
  stylistDiagnosisResults: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  hairCareItemsInfo: [],
  // eslint-disable-next-line react/default-props-match-prop-types
  scalpCareItemsInfo: [],
  // eslint-disable-next-line react/default-props-match-prop-types
  inFillItemsInfo: [],
  maskItemsInfo: [],
  // eslint-disable-next-line react/default-props-match-prop-types
  adenovitalItemsInfo: null,
  // eslint-disable-next-line react/default-props-match-prop-types
  aromaItemsInfo: null,
  // eslint-disable-next-line react/default-props-match-prop-types
  preCleanseShampooItemsInfo: null,
  changeCurrentScene: null,
};
HairAndScalpCarePage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  salonSolutionData: PropTypes.shape({}),
  authSalonSettingData: PropTypes.shape({}),
  updateDiagnosisResult: PropTypes.func.isRequired,
  diagnosisResult: PropTypes.shape({}),
  // eslint-disable-next-line react/no-unused-prop-types
  sublimicDiagnosisLogics: PropTypes.shape({}).isRequired,
  stylistDiagnosisResults: PropTypes.shape({}),
  hairCareItemsInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  scalpCareItemsInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  inFillItemsInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  maskItemsInfo: PropTypes.arrayOf(PropTypes.shape({})),
  adenovitalItemsInfo: PropTypes.arrayOf(PropTypes.shape({})),
  aromaItemsInfo: PropTypes.arrayOf(PropTypes.shape({})),
  preCleanseShampooItemsInfo: PropTypes.arrayOf(PropTypes.shape({})),
  handleOpenModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleChangeHomeCareHairItems: PropTypes.func.isRequired,
  handleChangeHomeCareScalpItems: PropTypes.func.isRequired,
  changeCurrentScene: PropTypes.func,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  salonSolutionData: state.salonSolutionList,
  authSalonSettingData: state.authSalonSettings,
  diagnosisResult: state.diagnosisResult,
  locale: state.locale,
  sublimicDiagnosisLogics: state.sublimicDiagnosisLogics,
  stylistDiagnosisResults: state.sublimicDiagnosis.stylistDiagnosisResults,
});
const mapDispatch = dispatch => ({
  updateDiagnosisResult: data => dispatch(updateDiagnosisResult(data)),
});
export default connect(mapState, mapDispatch)(HairAndScalpCarePage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/HairAndScalpCarePage/HairAndScalpCarePage.js